export const getLoggedInUser = () => {
    const token = localStorage.getItem("_stack360_token");
    if (!token) {
        throw new Error("user not logged in");
    }
    const tokenParts = token.split(".");
    // decode jwt 
    const user = JSON.parse(atob(tokenParts[1]));
    return user;
}
